module.exports = __webpack_public_path__ + "static/media/melissa.a57569c4.jpg";